export const BookingPlansSpecification = {
  permanentInspectionDetails: [
    '+BOOKING.PLAN.PRO.SPEC.PERMANENT_INSPECTION.INSPECTION',
    '+BOOKING.PLAN.PRO.SPEC.PERMANENT_INSPECTION.MAINTENANCE_SERVICE',
    '+BOOKING.PLAN.PRO.SPEC.PERMANENT_INSPECTION.MONITORING',
    '+BOOKING.PLAN.PRO.SPEC.PERMANENT_INSPECTION.ANOMALIES',
  ],
  predictiveMaintenanceDetails: [
    '+BOOKING.PLAN.PRO.SPEC.PREDICTIVE_MAINTANANCE.INFORMATION',
    '+BOOKING.PLAN.PRO.SPEC.PREDICTIVE_MAINTANANCE.SERVICE',
    '+BOOKING.PLAN.PRO.SPEC.PREDICTIVE_MAINTANANCE.DIAGNOSIS',
  ],
  automatedRecommendationsDetails: [
    '+BOOKING.PLAN.PRO.SPEC.AUTOMATED_RECOMMENDATIONS.SUGGESTIONS',
    '+BOOKING.PLAN.PRO.SPEC.AUTOMATED_RECOMMENDATIONS.ECONOMIC_OPERATION',
  ],
  includedFunctionsDetails_PartOne: [
    '+BOOKING.PLAN.PRO.SPEC.INCLUDED_FUNCTIONS.ONLINE_AVAILABILITY_CHECK',
    '+BOOKING.PLAN.PRO.SPEC.INCLUDED_FUNCTIONS.LEAKAGE_DETECTION',
    '+BOOKING.PLAN.PRO.SPEC.INCLUDED_FUNCTIONS.REFILL_DETECTOR',
    '+BOOKING.PLAN.PRO.SPEC.INCLUDED_FUNCTIONS.REMAINING_USEFUL_LIFE_OF_ELECTRODES',
    '+BOOKING.PLAN.PRO.SPEC.INCLUDED_FUNCTIONS.IGNITION_TIMES_CHECK',
    '+BOOKING.PLAN.PRO.SPEC.INCLUDED_FUNCTIONS.REMAINING_USEFUL_LIFE_OF_FUEL_CELL',
    '+BOOKING.PLAN.PRO.SPEC.INCLUDED_FUNCTIONS.FUEL_CELL_OUTPUT_CHECK',
  ],
  includedFunctionsDetails_PartTwo: [
    '+BOOKING.PLAN.PRO.SPEC.INCLUDED_FUNCTIONS.FIEL_CELL_TOO_LOW_RUNTIME_CHECK',
    '+BOOKING.PLAN.PRO.SPEC.INCLUDED_FUNCTIONS.DOMESTIC_HOT_WATER_HEAT_EXCHANGER_CHECK',
    '+BOOKING.PLAN.PRO.SPEC.INCLUDED_FUNCTIONS.BURNER_FUNKTION_CHECK',
    '+BOOKING.PLAN.PRO.SPEC.INCLUDED_FUNCTIONS.GAS_FAN_FUNCTION_CHECK',
    '+BOOKING.PLAN.PRO.SPEC.INCLUDED_FUNCTIONS.INTERNAL_PUMP_FUNCTION_CHECK',
    '+BOOKING.PLAN.PRO.SPEC.INCLUDED_FUNCTIONS.THREE_WAY_VALVE_FUNCTION_CHECK',
    '+BOOKING.PLAN.PRO.SPEC.INCLUDED_FUNCTIONS.OUTSIDE_TEMPERATURE_SENSOR_CHECK',
  ],
  includedFunctionsDetails_PartThree: [
    '+BOOKING.PLAN.PRO.SPEC.INCLUDED_FUNCTIONS.MAIN_HEAT_EXCHANGER_CHECK',
    '+BOOKING.PLAN.PRO.SPEC.INCLUDED_FUNCTIONS.BURNER_CLOCKING_CHECK',
    '+BOOKING.PLAN.PRO.SPEC.INCLUDED_FUNCTIONS.COMPRESSOR_CLOCKING_CHECK',
    '+BOOKING.PLAN.PRO.SPEC.INCLUDED_FUNCTIONS.SOLAR_THERMAL_FUNCTION_CHECK',
    '+BOOKING.PLAN.PRO.SPEC.INCLUDED_FUNCTIONS.HEATING_ROD_RUNTIME_CHECK',
  ],
  extendedParametersDetails: [
    '+BOOKING.PLAN.PLUS.SPEC.EXTENDED_PARAMETERS.READING_AND_WRITING',
    '+BOOKING.PLAN.PLUS.SPEC.EXTENDED_PARAMETERS.DATA_POINTS_ACCESS',
    '+BOOKING.PLAN.PLUS.SPEC.EXTENDED_PARAMETERS.SYSTEM_INSIGHTS_ACCESS',
  ],
  parameterComparisionDetails: [
    '+BOOKING.PLAN.PLUS.SPEC.PARAMETER_COMPARISION.COMPARING',
    '+BOOKING.PLAN.PLUS.SPEC.PARAMETER_COMPARISION.BACKUP',
  ],
  systemOverviewDetails: [
    '+BOOKING.PLAN.PLUS.SPEC.SYSTEM_OVERVIEW.OVERVIEW',
    '+BOOKING.PLAN.PLUS.SPEC.SYSTEM_OVERVIEW.DIAGNOSIS',
  ],
  recordingAndTrendingDetails: [
    '+BOOKING.PLAN.PLUS.SPEC.RECORDING_AND_TRENDING.VISUALIZATION',
    '+BOOKING.PLAN.PLUS.SPEC.RECORDING_AND_TRENDING.DATA_SELECTION',
    '+BOOKING.PLAN.PLUS.SPEC.RECORDING_AND_TRENDING.OPTIONS_SELECTION',
  ],
  quickCheckDashboardDetails: [
    '+BOOKING.PLAN.BASIC.SPEC.QUICK_CHECK_DASHBOARD.SYSTEMS_OVERVIEW',
    '+BOOKING.PLAN.BASIC.SPEC.QUICK_CHECK_DASHBOARD.INFORMATION',
    '+BOOKING.PLAN.BASIC.SPEC.QUICK_CHECK_DASHBOARD.PLANTS_OVERVIEW',
    '+BOOKING.PLAN.BASIC.SPEC.QUICK_CHECK_DASHBOARD.PERSONALIZATION',
  ],
  guidedCommissioningDetails: [
    '+BOOKING.PLAN.BASIC.SPEC.GUIDED_COMMISSIONING.TEST_SEQUENCES',
    '+BOOKING.PLAN.BASIC.SPEC.GUIDED_COMMISSIONING.GUIDED_COMMISSIONING',
    '+BOOKING.PLAN.BASIC.SPEC.GUIDED_COMMISSIONING.SPARE_PARTS_REPLACEMENT',
    '+BOOKING.PLAN.BASIC.SPEC.GUIDED_COMMISSIONING.HISTORY',
  ],
  errorListDetails: [
    '+BOOKING.PLAN.BASIC.SPEC.ERROR_LIST.DISPLAY',
    '+BOOKING.PLAN.BASIC.SPEC.ERROR_LIST.HOSTORICAL_LIST',
    '+BOOKING.PLAN.BASIC.SPEC.ERROR_LIST.FILTERING',
  ],
  basicParametersDetails: ['+BOOKING.PLAN.BASIC.SPEC.BASIC_PARAMETERS.READING_AND_WRITING'],
};
